import { useCallback } from "react";
import { UpdateUserDTO } from "@src/domain/dto/users";
import { UpdateUserUseCase } from "@src/application/useCases/user";
import { UserRepository } from "@src/infrastructure/repositories/user";

export type UpdateUserPayload = {
  userId?: number;
  authId?: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
};

export function getUpdateUserErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (!(error instanceof Error)) {
    return fallback;
  }

  const message = error.message.trim();
  if (!message) {
    return fallback;
  }

  return message;
}

export function useUpdateUser() {
  return useCallback(async (payload: UpdateUserPayload) => {
    const validated = UpdateUserDTO.validate(payload);
    if (!validated.success) {
      console.error("UpdateUser validation failed", validated.error);
      throw new Error("Invalid user data");
    }
    const dto = new UpdateUserDTO(validated.data);
    return new UpdateUserUseCase(new UserRepository()).execute(dto);
  }, []);
}
